import * as Actions from "../constants/DishConstants";
import { DISH_MODES } from "../constants/DishConstants";
import { precision } from "../utils/misc";
import { deepCopy } from "../utils/objects";
import deepMerge from "lodash.merge";

const InitialState = {
	mode: "",
	brandData: {},
	dishData: {},
	totalCalories: 0,
	totalProtein: 0,
	totalFibre: 0,
	quantity: 1,
	totalDishPrice: 0,
	priceWithoutOffers: 0,
	ingredients: {},
	segments: {},
	segmentsNotFulfilled: {},
	selectedAllergicIngredients: [],
	customizedSegments: {},
	cartIndex: null,
	availableItems: {},
	dishPricing: {},
	ingredientPricing: {},
	currentDishInventory: {},
	defaultPortionsNotFulfilled:{},
	showDefaultNotSatisfiedMessage: false,
	customisedPortions: {},
	pricingFailure: false
};

export const Dish = (state = InitialState, action: any) => {
	switch (action.type) {
		case Actions.SET_DISH_DATA:
			let {
				mode,
				segments: defaultSegments,
				initialInventory,
				availableItems: ingredientAvailablity,
				ingredients: ingredientsStaticData,
				dietaryPreferences,
				allergies,
				dishPricing,
				ingredientPricing,
			} = action.data;

			let segmentsNotFulfilled = {},
				totalCalories = 0,
				totalProtein = 0,
				totalFibre = 0,
				selectedAllergicIngredients = [],
				dishSegments,
				defaultPortionsNotFulfilled: any = {},
				showDefaultNotSatisfiedMessage:boolean = false,
				currentDishInventory = deepCopy(ingredientAvailablity),
				inventoryAlreadyAllocated = false,
				quantity = 1,
				selectedIngredientsMessage:any = [];

			switch (mode) {
				case DISH_MODES.CUSTOMIZE:
					//Merging the customized segments and the original dish segments to assign the portionselected property to
					//the respective ingredient
					dishSegments = deepMerge(deepCopy(defaultSegments), state.customizedSegments);
					inventoryAlreadyAllocated = true;
					quantity = state.quantity;
					break;

				default:
					//Make a copy of the segments so as to not overwrite the static data
					dishSegments = deepCopy(defaultSegments);
					break;
			}

			for (const segmentId in dishSegments) {
				let { ingredients } = dishSegments[segmentId];
				for (const ingredientId in ingredients) {
					//Parsing all the required data.
					let ingredient = ingredients[ingredientId];
					const ingredientStatic = ingredientsStaticData[ingredientId],
						{ dietaryDetails, name } = ingredientStatic,
						{ allergens } = dietaryDetails,
						{ quantity, amountPerPortion, portionSelected } = ingredient,
						{ defaultPortion, minPortion } = quantity,
						ingredientDynamicData = currentDishInventory[ingredientId];

					let selectedQuantity = 0,
						isSoldOut = false,
						isUserAllergic = false,
						ingredientAllergy,
						portionsPossible = 0,
						inventoryIsAllocated = false,
						readOnly = false;

					if (ingredientDynamicData) {
						const initialInventoryAmount = initialInventory[ingredientId].totalAvailableAmount;
						const { totalAvailableAmount } = ingredientDynamicData;
						let minimumAmountRequired = Math.max(amountPerPortion, minPortion * amountPerPortion),
							defaultPortionRequired = 0,
							defaultAmountRequired = 0;

						//TODO: Find a better way to do this.

						switch(mode) {
							case DISH_MODES.CREATE :
								//Conditions for sold out state
								//1.No available amount
								//        OR
								//2.Available amount is less than the min of minportion required or amountPerportion Required

								defaultPortionRequired = defaultPortion;

								if (defaultPortionRequired) {
									defaultAmountRequired = defaultPortionRequired * amountPerPortion;
								}
		
								if (!initialInventoryAmount || initialInventoryAmount < minimumAmountRequired) {
									isSoldOut = true;
								}

								//Ingredients where default portion are not being statisfied
								if (initialInventoryAmount < defaultAmountRequired) {
									if (initialInventoryAmount >= minimumAmountRequired) {
										defaultPortionRequired = Math.max(1, minPortion);
									} else {
										isSoldOut = true;
									}
									defaultPortionsNotFulfilled[ingredientId] = name;
									showDefaultNotSatisfiedMessage = true;
								}

								break;


							case DISH_MODES.CUSTOMIZE :

								defaultPortionRequired = portionSelected;

								//Show sold out for only items which were not selected by the user.

								if(!portionSelected) {
									if (!initialInventoryAmount || initialInventoryAmount < minimumAmountRequired) {
										isSoldOut = true;
									}
								}
								break;

							case DISH_MODES.EXPLORE : 

								defaultPortionRequired = defaultPortion;
								readOnly = true;
								break;

							default: 
								break;
						}

						//Set the default selected quantity for ingredient if it's not sold out.
						if (!isSoldOut && defaultPortionRequired) {
							selectedQuantity = defaultPortionRequired;
						}

						if (!isSoldOut && !inventoryAlreadyAllocated && !readOnly) {
							//Add it for updation in local inventory.
							const updatedInventoryValue = totalAvailableAmount - selectedQuantity * amountPerPortion;
							currentDishInventory[ingredientId].totalAvailableAmount = updatedInventoryValue;
							inventoryIsAllocated = true;
						}

					} else {
						isSoldOut = true;
					}

					for(const allergyId of allergens) {
						//Check if user is allergic to the allergen
						isUserAllergic = dietaryPreferences.includes(allergyId);
						if (isUserAllergic) {
							ingredientAllergy = allergies[allergyId];
							break;
						}
					}

					if (selectedQuantity) {
						//Add to the base calories for the dish.
						const { caloriesPerGram, proteinPerGram, fibrePerGram } = dietaryDetails;
						const ingredientCalories = caloriesPerGram * amountPerPortion * selectedQuantity;
						totalCalories += Math.max(0, ingredientCalories);

						//protein calculation.
						// const proteinPerGramValue = (proteinPerGram !== undefined && proteinPerGram !== null) ? proteinPerGram : 1;
						const ingredientProtein = proteinPerGram * amountPerPortion * selectedQuantity;
						totalProtein += Math.max(0, ingredientProtein);

						//fibre calculation
						// const fibrePerGramValue = (fibrePerGram !== undefined && fibrePerGram !== null) ? fibrePerGram : 1;
						const ingredientFibre = fibrePerGram * amountPerPortion * selectedQuantity;
						totalFibre += Math.max(0, ingredientFibre);

						if (isUserAllergic) selectedAllergicIngredients.push(name);

						if(!selectedIngredientsMessage.includes(name)) selectedIngredientsMessage.push(name);
					}

					ingredient = {
						...ingredient,
						selectedQuantity,
						isUserAllergic,
						ingredientAllergy,
						isSoldOut,
						portionsPossible,
						inventoryIsAllocated,
						readOnly
					};
					ingredients[ingredientId] = ingredient;
				}

				dishSegments[segmentId]["ingredients"] = ingredients;
				dishSegments[segmentId]['selectedIngredientsMessage'] = selectedIngredientsMessage;

				selectedIngredientsMessage = [];
			}

			segmentsNotFulfilled = checkforUnfulfilledSegments(dishSegments);
			totalCalories = Math.max(0, Math.ceil(totalCalories));
			totalProtein = Math.max(0, Math.ceil(totalProtein));
			totalFibre = Math.max(0, Math.ceil(totalFibre));

			return {
				...state,
				...action.data,
				totalCalories,
				totalProtein,
				totalFibre,
				quantity: quantity,
				segments: dishSegments,
				segmentsNotFulfilled: segmentsNotFulfilled ?? { ...state.segmentsNotFulfilled },
				selectedAllergicIngredients,
				dishPricing,
				ingredientPricing,
				currentDishInventory,
				defaultPortionsNotFulfilled,
				showDefaultNotSatisfiedMessage
			};

		case Actions.SET_MISC_DISH_DATA:
			//Set any of the fields in dish data.
			//Usually used to set static data before navigating to the dish page
			return {
				...state,
				...action.data,
			};

		case Actions.CLEAR_DISH_DATA:
			//Cleanup function
			return {
				...InitialState,
			};

		case Actions.CHANGE_DISH_QUANTITY:
			//Change Dish quantity
			let newDishQuantity = state.quantity;
			switch (action.data) {
				case "INCREMENT":
					newDishQuantity++;
					break;

				case "DECREMENT":
					newDishQuantity > 1 ? newDishQuantity-- : (newDishQuantity = 1);
					break;

				default:
					break;
			}
			return {
				...state,
				quantity: newDishQuantity,
			};

		case Actions.CHANGE_INGREDIENT_QUANTITY:
			//Handle User Customisations
			const { ingredientId, segmentId, type, isUserAllergic } = action.data;
			let segments: any = deepCopy(state.segments),
				updatedCalories = state.totalCalories,
				updatedProtein = state.totalProtein,
				updatedFibre = state.totalFibre,
				segmentToUpdate: any = segments[segmentId],
				ingredientToUpdate: any = segmentToUpdate["ingredients"][ingredientId],
				userSelectedIngredientsText:any = segmentToUpdate["selectedIngredientsMessage"],
				{
					selectedQuantity: ingredientQuantity,
					amountPerPortion,
					inventoryIsAllocated: ingredientInventoryisAllocated,
				} = ingredientToUpdate,
				updatedAllergicIngredients: any = deepCopy(state.selectedAllergicIngredients),
				ingredientStaticData = state.ingredients[ingredientId as keyof typeof state.ingredients],
				{ name } = ingredientStaticData,
				newDishInventory = deepCopy(state.currentDishInventory),
				customisedPortions = deepCopy(state.customisedPortions);

			let newDishsegments;
			const { dietaryDetails } = ingredientStaticData;

			let { caloriesPerGram, proteinPerGram, fibrePerGram } = dietaryDetails;
			let caloriesPerPortion = Math.max(0, Math.ceil(caloriesPerGram * amountPerPortion));
			let proteinPerPortion = Math.max(0, Math.ceil(proteinPerGram * amountPerPortion));
			let fibrePerPortion = Math.max(0, Math.ceil(fibrePerGram * amountPerPortion));

			let updatedIngredientAmount = newDishInventory[ingredientId].totalAvailableAmount;
			const ingredientAmountDiff = amountPerPortion;

			//Handle Quantity and Calories Change
			switch (type) {
				case "INCREMENT":
					ingredientQuantity++;
					updatedIngredientAmount -= ingredientAmountDiff;
					updatedCalories += caloriesPerPortion;
					updatedProtein += proteinPerPortion;
					updatedFibre += fibrePerPortion;
					if (isUserAllergic) {
						const alreadyAdded = updatedAllergicIngredients.includes(name);
						if (!alreadyAdded) {
							updatedAllergicIngredients.push(name);
						}
					}

					if(!userSelectedIngredientsText.includes(name)) userSelectedIngredientsText.unshift(name);
					
					if(segmentId in customisedPortions) {
						if(ingredientId in customisedPortions[segmentId]['ingredients']) {
							customisedPortions[segmentId]['ingredients'][ingredientId].portionsCustomised++;
						} else {
							customisedPortions[segmentId]['ingredients'][ingredientId] = { portionsCustomised: 1 }
						}
					} else {
						customisedPortions[segmentId] = { 'ingredients': { [ingredientId]: { portionsCustomised: 1 } } }
					}

					break;

				case "DECREMENT":
					ingredientQuantity--;
					updatedIngredientAmount += ingredientAmountDiff;
					updatedCalories -= caloriesPerPortion;
					updatedProtein -= proteinPerPortion;
					updatedFibre -= fibrePerPortion;
					if (isUserAllergic) {
						updatedAllergicIngredients = updatedAllergicIngredients.filter((item: any) => item !== name);
					}

					if(!ingredientQuantity) userSelectedIngredientsText = userSelectedIngredientsText.filter((ingName:any) => ingName !== name);

					if(segmentId in customisedPortions) {
						if(ingredientId in customisedPortions[segmentId]['ingredients']) {
							customisedPortions[segmentId]['ingredients'][ingredientId].portionsCustomised--;
						} else {
							customisedPortions[segmentId]['ingredients'][ingredientId] = { portionsCustomised: -1 }
						}
					} else {
						customisedPortions[segmentId] = { 'ingredients': { [ingredientId]: { portionsCustomised: -1 } } }
					}
					break;

				default:
					break;
			}

			newDishInventory[ingredientId].totalAvailableAmount = updatedIngredientAmount;

			updatedCalories = precision(Math.max(0, updatedCalories), 2);
			updatedProtein = precision(Math.max(0, updatedProtein), 2);
			updatedFibre = precision(Math.max(0, updatedFibre), 2);

			if (!ingredientQuantity) ingredientInventoryisAllocated = false;

			//Update the ingredient and segment
			ingredientToUpdate = {
				...ingredientToUpdate,
				selectedQuantity: ingredientQuantity,
				inventoryIsAllocated: ingredientInventoryisAllocated,
			};

			segmentToUpdate["ingredients"][ingredientId] = ingredientToUpdate;
			segmentToUpdate['selectedIngredientsMessage'] = userSelectedIngredientsText;
			newDishsegments = { ...state.segments, [segmentId]: segmentToUpdate };

			const unfulfilledSegments = checkforUnfulfilledSegments(newDishsegments);

			//Check if state update is needed or not.
			return {
				...state,
				totalCalories: updatedCalories,
				totalProtein: updatedProtein,
				totalFibre: updatedFibre,
				segments: newDishsegments,
				segmentsNotFulfilled: unfulfilledSegments,
				selectedAllergicIngredients: updatedAllergicIngredients,
				currentDishInventory: newDishInventory,
				customisedPortions
			};

		// case Actions.SET_USER_HAS_ALLOWED_ALLERGIC:

		//                                 return {
		//                                     ...state,
		//                                     userHasAllowedAllergic: [
		//                                         ...state.userHasAllowedAllergic,
		//                                         action.data
		//                                     ]
		//                                 }

		default:
			return {
				...state,
			};
	}
};

//Helper Functions

function checkforUnfulfilledSegments(segments: any) {
	let segmentsNotFulfilled = {};
	for (const segmentId in segments) {
		const segmentData = segments[segmentId];

		//Check if Update values are meeting the segment conditions
		const { quantity, ingredients } = segmentData as any;
		const { minPortion, maxPortion } = quantity;
		let totalSegmentPortions = 0;
		let ruleNotMet = "";

		for (let ingredientId in ingredients) {
			totalSegmentPortions += ingredients[ingredientId].selectedQuantity;
		}

		if (totalSegmentPortions < minPortion) {
			ruleNotMet = "min";
		} else if (totalSegmentPortions > maxPortion) {
			ruleNotMet = "max";
		}

		if (totalSegmentPortions === maxPortion) {
			segments[segmentId]["maxPortionsReached"] = true;
		} else {
			segments[segmentId]["maxPortionsReached"] = false;
		}

		if (ruleNotMet) {
			segmentsNotFulfilled = { ...segmentsNotFulfilled, [segmentId]: ruleNotMet };
		}
	}

	return segmentsNotFulfilled;
}

export default Dish;
